import React, {Component} from 'react';
import { config } from "../libs/utils/Const";
import $ from 'jquery';
import '../index.css';
import {ApiClient} from "../libs/apiClient/ApiClient";
import 'jquery-ui-dist/jquery-ui';

let apiClient = ApiClient.getInstance();

class ArticulosVentaModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            Cond : [],
        };

    };
    
    moverModal = () => {
        $(document).ready(function () {
            $("#ModalVenta").draggable({
                handle: ".modal-header"
            });
        });
    };

    CloseArticulosVenta = ()=>{
        $('#ModalVenta').modal('hide');
    }
   
    render (){
        const {searchItemsValue,hadleChangeTable,items,selectItems} = this.props;
        const {Cond} = this.state;
        return (
        <div> 
            {/*--------------- MODAL ARTICULOS VENTA ---------------*/}
            <div class="modal fade" id="ModalVenta" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" >
                <div class="modal-dialog modal-md" role="document" >
                    <div class="modal-content" >
                    <div class="modal-header" id="HeaderModalVenta" style={{background: '#2d75bd', borderRadius: '0' }} onMouseDown={this.moverModal}>
                        <h5 class="modal-title text-white" id="exampleModalLabel">Artículos Venta</h5>
                        <button type="button" class="close" onClick={this.CloseArticulosVenta} aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                    {/* <form> */}
                            <input
                                id="searchItem"
                                type="search"
                                className="form-control"
                                autoComplete="off"
                                placeholder="Buscar artículo"
                                
                                value={searchItemsValue || '' } 
                                onChange={(event)=>hadleChangeTable(event)}
                                />
                                &nbsp;
                                
                            <div>                                  
                                <table className="table scroll" >
                                    <thead >
                                        <tr className="text-light bg-primary" >
                                        {/* <th scope="col">#</th> */}
                                        <th scope="col" style={{width:'30%'}}>Artículo</th>
                                        <th scope="col" style={{width:'60%'}}>Descripción</th>
                                        <th scope="col" style={{width:'10%'}}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => {
                                            return (
                                            <tr key={'itemsBoni' + index}>
                                                <td style={{width:'30%',fontSize: 12}}>{item.ItemCode}</td>
                                                <td style={{width:'60%',fontSize: 12}}>{item.ItemName}</td>
                                                <td style={{width:'10%'}}>
                                                <button
                                                    className="btn btn-sm"
                                                    type="button"
                                                    style={{ backgroundColor: config.navBar.iconBackground, color: config.navBar.iconModal }}
                                                    onClick={() => selectItems(item)}> 
                                                    <i className="fas fa-plus-circle"></i> 
                                                </button>
                                                </td>
                                            </tr>)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                    {/* </form> */}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" onClick={this.CloseArticulosVenta}>Cerrar</button>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }
}
export default ArticulosVentaModal